module.exports = __webpack_public_path__ + "img/preview-12.03b88034.png";